import React, { useState, useEffect } from 'react';
import { Alert, Form, Button, Modal, Spinner, Row } from 'react-bootstrap';
import { Formik } from 'formik';
import { useSelector, useDispatch } from "react-redux";

import { schema } from './schema';
import CustomPagint from '../CustomPagint';
import CustomTable from '../CustomTable';
import { getSelectSearch } from '../../redux/selectSearch/actions';

const SelectSearch = ({ labelName, 
                        name, 
                        id, 
                        options, 
                        isLoading, 
                        searchColumns, 
                        endpoint, 
                        addOption, 
                        handleChange, 
                        values,
                        error,
                        isFormik,
                        value,
                        setValue,
                        required }) => {
  const [isOpenSearchModal, setisOpenSearchModal] = useState(false);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState('');
  const { isLoadingSearch,
          recordsCount,
          searchResults,
          searchFail } = useSelector(state => state.selectSearch);
  const dispatch = useDispatch();
  const pages = Math.ceil(recordsCount / limit);
  const handleCloseModal = () => setisOpenSearchModal(false);
  const handleOpenModal = () => setisOpenSearchModal(true);
  
  const getSearchData = (off=offset, lim=limit, filt=filter) =>
    dispatch(
      getSelectSearch(endpoint, {
        offset: off,
        limit: lim,
        filter: filt
      })
    );

  useEffect(() => {
    getSearchData();
  }, []);

  const onSubmit = (values) => {
    getSearchData(0, limit, values.search);
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      const filter = e.target.value;
      setFilter(filter);
      getSearchData(0, limit, filter);
      
    }
  }

  return (
    <>
      <Form.Group className="invalid" controlId={id}>
        <Form.Label>{labelName}</Form.Label>
        <div className="d-flex">
          <Form.Group as={Row} className="m-0">
            <div className="d-flex align-items-center">
              {
                isFormik ? (
                  <Form.Control 
                    onChange={handleChange}
                    value={values[name]}
                    className="flex-grow-1 rounded-pill" 
                    name={name} 
                    as="select"
                    isInvalid={error ? true : false} 
                    custom>
                    <option value="" disabled>Seleccionar una opción...</option>
                    {
                      options.map((option, index) => (
                        <option  key={index} value={option.value}>{option.label}</option>
                      ))
                    }
                  </Form.Control>
                ) : (
                  <Form.Control 
                    className="flex-grow-1 rounded-pill" 
                    name={name} 
                    as="select"
                    required={required}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    custom>
                    <option value="" disabled>Seleccionar una opción...</option>
                    {
                      options.map((option, index) => (
                        <option  key={index} value={option.value}>{option.label}</option>
                      ))
                    }
                  </Form.Control>
                )
              }
              {
                isLoading && (
                  <Spinner className="mx-1" animation="border" size="sm" />
                )
              }
            </div>
          </Form.Group>
          <Button className="rounded-pill" variant="light" onClick={handleOpenModal}><i className="material-icons">search</i></Button>
        </div>
        {
          error && (
            <p className="text-danger pl-2">{error}</p>
          )
        }
      </Form.Group>
      <Modal
       show={isOpenSearchModal} 
       onHide={handleCloseModal}
       size="lg">
        <Formik initialValues={{
          search: '',
        }} validationSchema={schema} onSubmit={onSubmit}>
            {({
              handleSubmit,
              handleChange,
              values,
          }) => (
            <Form id="searchForm" onSubmit={handleSubmit} noValidate>
              <Modal.Header closeButton>
                <Modal.Title>Buscar</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Control 
                  name="search" 
                  onChange={handleChange} 
                  value={values.search}
                  type="search" 
                  placeholder="Buscar"
                  onKeyPress={handleKeyPress}
                  className="mb-3 rounded-pill" />
                {
                  searchFail && (
                    <Alert variant="danger">{searchFail}</Alert>
                  ) 
                }
                <CustomTable 
                  isLoadingData={isLoadingSearch} 
                  columns={searchColumns} 
                  data={searchResults}
                  addFunc={addOption}
                  closeSearchModal={handleCloseModal} />
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={recordsCount}
                  pages={pages}
                  pagFunc={getSearchData} />
              </Modal.Body>
              <Modal.Footer>
                <Button className="rounded-pill" variant="secondary" onClick={handleCloseModal}>Cerrar</Button>
                {/* <Button variant="primary" >Buscar</Button> */}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  )
}
export default SelectSearch;